import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "hezi-disks-card-item" }
const _hoisted_2 = { class: "hezi-disks-card-item-left" }
const _hoisted_3 = { class: "hezi-disks-card-item-icon-wrap" }
const _hoisted_4 = {
  key: 0,
  class: "hezi-disks-card-item-icon-tips"
}
const _hoisted_5 = { class: "hezi-disks-card-item-name" }
const _hoisted_6 = ["title"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "hezi-disks-card-item-progress"
}
const _hoisted_10 = { class: "hezi-disks-card-item-right" }
const _hoisted_11 = { class: "hezi-disks-card-item-right-btns" }

import { ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  props: {
    icon: null,
    name: null,
    tag: null,
    status: null,
    percent: null,
    bgColor: null,
    readonly: { type: Boolean },
    editName: { type: Boolean },
    backupError: { type: Boolean },
    haveBubbles: { type: Boolean },
    onRename: null
  },
  setup(__props: any) {

const props = __props as {
  icon: 'buildin' | 'cloud' | 'u-disk' | 'Samba' | 'WebDAV'
  name: string
  tag?: string
  status: string
  percent: number
  bgColor?: string
  readonly?: boolean
  editName?:boolean
  backupError?:boolean
  haveBubbles?:boolean
  onRename?: (newName:string) => Promise<boolean>
}



const renameInputRef = ref<HTMLInputElement>()
const isEdit = ref(false)

const handleOnRename = () => {
  isEdit.value = true
  if (renameInputRef.value) {
    renameInputRef.value.focus()
    renameInputRef.value.value = props.name
    setTimeout(() => {
      renameInputRef.value && renameInputRef.value.select()
    }, 100)
  }
}

const  handleOnRenameInputBlur = async () => {
  if (
    renameInputRef?.value?.value && renameInputRef.value.value !== props.name 
    &&
    typeof props.onRename === 'function'
  ) {
    props.onRename(renameInputRef.value.value as string)
  }
  isEdit.value = false
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("i", {
          class: _normalizeClass(["hezi-disks-card-item-icon", [props.icon, props.backupError ? 'error' : '']])
        }, null, 2),
        (props.haveBubbles)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "backuptips")
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", {
            title: props.name
          }, _toDisplayString(props.name), 9, _hoisted_6),
          _withDirectives(_createElementVNode("input", {
            placeholder: "请输入磁盘名称",
            ref_key: "renameInputRef",
            ref: renameInputRef,
            onBlur: handleOnRenameInputBlur
          }, null, 544), [
            [_vShow, __props.editName && isEdit.value]
          ]),
          (!!props.readonly)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "只读"))
            : _createCommentVNode("", true),
          (!!props.tag)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(props.tag), 1))
            : _createCommentVNode("", true)
        ]),
        (props?.percent >= 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", {
                style: _normalizeStyle({ width: `${Math.max(props?.percent, 0)}%` }),
                class: _normalizeClass([props.bgColor, props.icon])
              }, null, 6)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("span", null, _toDisplayString(props.status), 1),
      _createElementVNode("div", _hoisted_11, [
        (props.editName)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              onClick: handleOnRename
            }, "重命名"))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "btns")
      ])
    ])
  ]))
}
}

})